var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holoverz-info-banner"},[_c('div',{staticClass:"holoverz-info-banner__inner"},[_c('strong',[_vm._v(_vm._s(_vm.$t('holoverzInfoRow.text')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }